/** 引入crpyto-js */
import CryptoJS from 'crypto-js'

/** 引入message弹窗 */
import { Message, MessageBox } from 'element-ui'

/** 文件上传调用接口 */
export const uploadFile = async isMulti => {
    let result = await UploadMethod(isMulti).catch(e => {
        console.log(e);
        return e;
    });
    if(result) return result;
};

/** 封装文件上传方法 */
const UploadMethod = isMulti => {
    return new Promise((resolve,reject) => {
        /** 创建input */
        let input = document.createElement('input');
        /** 设置input的样式，不让他显示出来 */
        input.setAttribute('style',';width: 0; height: 0; overflow: hidden');
        input.setAttribute('type','file');

        if(isMulti) input.setAttribute('multiple','multiple');
        document.body.appendChild(input);

        /** 设置监听input的变化 */
        input.addEventListener('change',() => {
            let files = input.files
            if(files.length > 0) {
                resolve({code: 200, data: files});
            } else {
                reject({code: 400, message: '网络错误'})
            }
        });
        input.click();
    })
}


/**
 * 消息弹窗提示
 * @param {string} type     success/warning/info/error
 * @param {String} params   提示信息
 * @param {Number} time     弹窗显示得时间
 */
export const MessageTime = (type='success',message, time=2000) => {
    Message({
        type,
        message,
        duration: time
    })
}

/**
 * 删除等再次确认提示
 * @param {string} message  提示信息
 * @returns 
 */
export const mzConfirm = (message) => {
    return new Promise((resolve, reject) => {
        MessageBox.confirm(message,'温馨提示',{
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            center: true
        }).then(() => {
            resolve(true)
        }).catch(() => {
            reject(false)
        })
    })
}

/**
 * 动态添加数据，有就添加，没有则为空
 * @param {Object} obj    需要转变的数据结构
 */
export const setDataCons = (obj) => {
    let parmas = {}
    for(let key in obj) {
        if(obj[key] !== '' && obj[key] !== 0 && obj[key] != null && obj[key] != undefined) {
            parmas = {...parmas,[key]: obj[key]}
        }
    }
    return parmas
}

/**
 * @description 去除空格
 * @param { string } str 待处理字符串
 * @param  { number } type 去除空格类型 1-所有空格  2-前后空格  3-前空格 4-后空格 默认为1
 */
export function trim(str, type = 1) {
    if (type && type !== 1 && type !== 2 && type !== 3 && type !== 4) return;
    switch (type) {
        case 1:
            return str.replace(/\s/g, '');
        case 2:
            return str.replace(/(^\s)|(\s*$)/g, '');
        case 3:
            return str.replace(/(^\s)/g, '');
        case 4:
            return str.replace(/(\s$)/g, '');
        default:
            return str;
    }
}


/**
 * 定义身份证前两位数字
 * @vcity
 */
export const vcity = {
    11:"北京",12:"天津",13:"河北",14:"山西",15:"内蒙古",
    21:"辽宁",22:"吉林",23:"黑龙江",31:"上海",32:"江苏",
    33:"浙江",34:"安徽",35:"福建",36:"江西",37:"山东",41:"河南",
    42:"湖北",43:"湖南",44:"广东",45:"广西",46:"海南",50:"重庆",
    51:"四川",52:"贵州",53:"云南",54:"西藏",61:"陕西",62:"甘肃",
    63:"青海",64:"宁夏",65:"新疆",71:"台湾",81:"香港",82:"澳门",91:"国外"
};

/**
 * 图片压缩
 * @param {*} image 
 * @param {*} file 
 */
export const  compressUpload = (image, file) => {
    let canvas = document.createElement('canvas')
    let ctx = canvas.getContext('2d')
    // let initSize = image.src.length
    let { width } = image, { height } = image
    canvas. width = width
    canvas.height = height
    ctx.fillRect(0, 0, canvas.width, canvas.height)
    ctx.drawImage(image, 0, 0, width, height)
    
    // 进行最小压缩0.1
    let compressData = canvas.toDataURL(file.type || 'image/jpeg', 0.1)
    
    // 压缩后调用方法进行base64转Blob，方法写在下边
    let blobImg = dataURItoBlob(compressData)
    return blobImg
}


function dataURItoBlob(data) {
    let byteString;
    if(data.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(data.split(',')[1])
    }else {
        byteString = unescape(data.split(',')[1])
    }
    let mimeString = data
        .split(',')[0]
        .split(':')[1]
        .split(';')[0];
    let ia = new Uint8Array(byteString.length)
    for( let i = 0; i < byteString.length; i += 1) {
        ia[i] = byteString.charCodeAt(i)
    }
    return new Blob([ia], {type: mimeString})
}

/**
 * 用于对数据单选和全选的筛除
 * @param {object} selection  单选或者全选是的数据源 
 */
export const batchDealWith = (selection) => {
    let select = JSON.parse(JSON.stringify(selection))
    select = select.filter(it => {
        return it.opts
    })
    return select
}

/**
 * 将时间戳转换成日期
 * @param {String} times   //时间戳  时间戳为10位需*1000，时间戳为13位的话不需乘1000
 */

export const timestampToTime = (times) => {
    var date = new Date(times);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        let Y = date.getFullYear() + '-',
        M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-',
        D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate())
        // h = (date.getHours() < 10 ? '0'+date.getHours() : date.getHours()) + ':';
        // m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) + ':';
        // s = (date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds());
        return Y+M+D
}

/**
 * 将日期转换成时间戳
 * @param {Date} time   //日期对象，格式为 2020-10-10 、2020/10/10
 */
export const timeTotimes = (time) => {
    let date = new Date(time)
    let times = date.getTime(); 
    return times
}

/**
 * 日期选择跨度不能大于2个月
 * @param {String} mintime  开始时间戳
 * @param {String} maxtime  结束时间戳
 */
export const limitTime = (mintime,maxtime) => {
    if (maxtime - mintime > (60*60*1000*24*60)){
        Message({
            type: 'warning',
            message: '日期跨度不能大于2个月'
        })
        return false
    }
    return true
}

/**
 * 设置默认时间
 * @param {String} type   时间类型，month/day
 * @param {Number} spDay  时间跨度，根据类型而定
 * @returns 
 */
export const setTime = (type,spDay) => {
    let date = new Date()
    let year = ''
    let month = ''
    let day = ''
    if(type === 'month') {
        date.setMonth(date.getMonth() - spDay)
        year = date.getFullYear() + '-'
        month = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1)
        return year + month
    }
    if (type === 'day') {
        date.setDate(date.getDate() - spDay)
        year = date.getFullYear() + '-'
        month = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-'
        day = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate())
        return year + month + day
    }
}

/**
 * 输入当前日期获取上周日期
 * @param {*} typeId 
 * @returns 
 */
export const getLastWeek = (input_day) => {
        let oneDayTime = 1000 * 60 * 60 * 24 
        let today = new Date(input_day)
        console.log(today)
        // 若那一天是周末时，则强制赋值为7
        let todayDay = today.getDay() || 7 
        let endDate = new Date(
            today.getTime() - oneDayTime * (todayDay)
        )
        let startDate = new Date(
            endDate.getTime() - oneDayTime * 6
        )
        let sYear = startDate.getFullYear()
        let sMonth = startDate.getMonth() + 1 >= 10 ?  startDate.getMonth() + 1 : '0'+ (startDate.getMonth() + 1)
        let sDay = startDate.getDate() >= 10 ? startDate.getDate() : '0' + startDate.getDate()
        let start = sYear + '-' + sMonth + '-' + sDay
        let eYear = endDate.getFullYear()
        let eMonth = endDate.getMonth() + 1 >= 10 ?  endDate.getMonth() + 1 : '0'+ (endDate.getMonth() + 1)
        let eDay = endDate.getDate() >= 10 ? endDate.getDate() : '0' + endDate.getDate()
        let end = eYear + '-' + eMonth + '-' + eDay
        let dateList = [start,end]
        return dateList
}

/**
 * 
 * @param {Number} value 
 * @returns 
 */
export const checkNum = (value) => {
    if(isNaN(value)) {
        MessageTime('error',`只能为数字`);
        return false
    }
    return true
}

/**
 * 判断大于0的正整数
 * @param {*} value 
 * @returns 
 */
export const checkInt = (value) => {
    if(isNaN(value)) {
        MessageTime('error',`只能为数字`);
        return false
    }
    if(!value) {
        MessageTime('error',`填写后再保存`);
        return false
    }else if(value <= 0) {
        MessageTime('error',`必须为大于0得数字`);
        return false
    } else if (value.indexOf('.') !== -1) {
        MessageTime('error',`不能存在小数点`);
        return false
    }
    return true
}

export const checkPageInt = (value) => {
    if(isNaN(value) && value) {
        MessageTime('error',`只能为数字`);
        return false
    }
    if(value <= 0) {
        MessageTime('error',`必须为大于0得数字`);
        return false
    } else if (value.indexOf('.') !== -1) {
        MessageTime('error',`不能存在小数点`);
        return false
    }
    return true
}

/**
 * 判断大于等于0的正整数
 * @param {*} value 
 * @returns 
 */
export const checkIntZ = (value) => {
    if(isNaN(value)) {
        MessageTime('error',`只能为数字`);
        return false
    }
    if(value < 0) {
        MessageTime('error',`必须为大于或等于0的数字`);
        return false
    } else if (value.indexOf('.') !== -1) {
        MessageTime('error',`不能存在小数点`);
        return false
    }
    return true
}
/**
 * 用于排序
 * @param {Array} arr   数组
 * @returns 
 */
export const MzSet = (arr) => {
    let len = arr.length
    for(let i=0; i<len; i++) {
        for(let j=0; j<len-1-i;j++) {
            if(arr[j].num > arr[j+1].num) {
                var temp = arr[j+1]
                arr[j+1] = arr[j]
                arr[j] = temp
            }
        }
    }
    return arr
}


/**
 * 一位小数
 * @param {*} value 
 * @returns 
 */
export const checkFloat = (value) => {
    let twoDecimal = /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/;
    if(!value) {
        MessageTime('error',`填写后再保存`);
        return false
    } else if (value <= 0) {
        MessageTime('error',`必须为大于0得数字`);
        return false
    } else if(!twoDecimal.test(value)) {
        MessageTime('error',`最多保留两位小数`);
        return false
    }
    return true
}

/**
 * 
 * @param {Array} Arr   //改变的数组
 * @param {String} startName  //开始的字符串
 * @param {String} endName    // 结束字符串名称
 * @returns 
 */
export const ClearTime = (Arr,startName,endName) => {
    Arr = Arr.map(it => {
        it[startName] = it[startName] ? it[startName].replace('T00:00:00','') : ''
        it[endName] = it[endName] ? it[endName].replace('T00:00:00','') : ''
        return it
    })
    return Arr
}

/**
 * 判断是否手机登陆
 * @returns flag 为true 是电脑，false 是手机
 */
export const ISPC = () => {
    let userAgentInfo = navigator.userAgent;
    let Agents = ["Android", "iPhone",
                "SymbianOS", "Windows Phone",
                "iPad", "iPod"];
    let flag = true;
    for (let v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
        }
    }
    return flag;
}


/** 正则验证手机号码 */
export const CheckPhone = (value) => {
    let reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
    if(!reg_tel.test(value)) {
        return false
    } else {
        return true
    }
}



/**
 * 数组去重 
 * @param {*} key  //去重的 属性
 * @param {*} arr //去重的数组
 * @returns 
 */
 export const SetArray = (arr,key = '') => {
    let map = new Map()
    if(key) {
        for (let i of arr) {
            map.set(i[key], i)
        }
    } else {
        for (let i of arr) {
            map.set(i, i)
        }
    }
    arr = [...map.values()]
    return arr
}


// 对象深拷贝
export const deepCopy = (obj) => {
	var result = Array.isArray(obj) ? [] : {};
	for (var key in obj) {
		if (obj.hasOwnProperty(key)) {
			if (typeof obj[key] === 'object' && obj[key] !== null) {
				result[key] = deepCopy(obj[key]); //递归复制
			} else {
				result[key] = obj[key];
			}
		}
	}
	return result;
}